import { render, staticRenderFns } from "./messageCard.vue?vue&type=template&id=a5e7a288&"
import script from "./messageCard.vue?vue&type=script&lang=js&"
export * from "./messageCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports